import styled from 'styled-components';

export const StyledFooter = styled.footer.attrs({ className: 'bg-light' })`
  min-height: 150px;
`;
